<template>
  <div>
    <!-- <h1>manage_elements</h1> -->
    <section v-if="!isAdvancedMode">
      <p>You can edit an element.</p>
      <p>You can correct a typo regarding an element.</p>
    </section>
    <section v-else>
      <p>You can customize the automated representation of elements in the <a href="https://www.swi-prolog.org">PROLOG</a> language by clicking on the element after choosing PROLOG mode.</p>
      <p>You delete the current representation by clicking x then you start to elaborate your own representation.</p>
      <p>A checked input data box means that this data must be provided by the user. If you do not agree, uncheck.</p>
      <p>You start to elaborate your own representation and each time you type a comma and then you start typing new text, you see boxes appear to fill in.</p>
      <p>Each box corresponds to a sub-element of the initial element written in natural language. In the <pre>Natural language representation</pre> box, you can write a natural language representation. If it is input data, this is the text that user will see.</p>
      <p>For each box you decide whether it is an input data by checking.</p>
      <p>Each sub-element will appear in the list of the elements</p>
    </section>
  </div>
</template>
<script>
export default {
  computed: {
    isAdvancedMode () {
      return this.$store.state.mode === 'advanced'
    },
  },
}
</script>